import {
  Button,
  Center,
  Flex,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { TextHTML } from "../../../../components";
import { useTranslation } from "react-i18next";

interface Iprops {
  text: string;
  title: string;
  description: string;
}

const LayoutInfoAuth = ({ text, title, description }: Iprops) => {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleRedirect = () => {
    navigate("/autenticacao/acessar-conta");
  };
  return (
    <Center px={{ base: 24, 991: 100, 1300: 200 }} w="100%">
      <Center w="100%">
        <Flex
          w="100%"
          maw={1680}
          bg="basic.0"
          align="center"
          justify="center"
          direction={{ base: "column" }}
          gap={80}
          style={{
            boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.1)",
            borderRadius: "20px",
            overflow: "hidden",
          }}
          p={{ base: "32px 16px", 991: "80px 80px", 1600: "80px 142px" }}
        >
          <Flex direction="column" gap={48} align="center" justify="center">
            <Flex direction="column" gap={16} align="center" justify="center">
              <Flex direction="column" gap={8}>
                <Text
                  tt="uppercase"
                  data-aos="fade-top"
                  data-aos-easing="linear"
                  data-aos-duration="500"
                  fw={500}
                  fz={{ base: 14, 991: 18 }}
                  lh={{ base: "22px", 991: "28px" }}
                  color="primary.1"
                  ff="Barlow"
                  ta="center"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  {text}
                </Text>
                <Title
                  data-aos="fade-top"
                  data-aos-easing="linear"
                  data-aos-duration="800"
                  fw={700}
                  fz={{ base: 36, 991: 48 }}
                  lh={{ base: "40px", 991: "68px" }}
                  color="basic.5"
                  ta="center"
                >
                  {title}
                </Title>
              </Flex>
              <TextHTML
                maw="1138px"
                fz={{ base: 16, 991: 24 }}
                lh={{ base: "32px", 991: "40px" }}
                data-aos={"fade-top"}
                color={theme.colors.basic[5]}
                ta="center"
                textHTML={description}
              />
            </Flex>
            <Button
              onClick={handleRedirect}
              fullWidth
              variant="primary"
              maw={{ base: 348, 991: 276 }}
            >
              {t("autenticacao.button_signin.title")}
            </Button>
          </Flex>
        </Flex>
      </Center>
    </Center>
  );
};

export default LayoutInfoAuth;
